import React, { useEffect } from 'react'

import 'antd/dist/antd.css'
import AuthForm from './scenes/AuthForm/index'
import './index.css'

function Authorization () {
  return (
    <div className='boxStyle'>
      <main className='main-grid-child'>
        <AuthForm />
      </main>
    </div>
  )
}

export default Authorization
